/**
 * The privacy page's words that a test can hold without a browser (Personvern.tsx, 2026-10-14).
 */

/** «Funksjonene X, Y og Z blir satt på pause til Min Masjid har godkjent den nye siden» — or nothing when nothing pauses. */
export function pauseWarning(labels: string[]): string {
  if (!labels.length) return '';
  const list = labels.length === 1 ? labels[0] : `${labels.slice(0, -1).join(', ')} og ${labels[labels.length - 1]}`;
  return `${labels.length === 1 ? 'Funksjonen' : 'Funksjonene'} ${list} blir satt på pause til Masjid har godkjent den nye siden.`;
}
